import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { UserService } from '../../../_core/services/user.service';
import { User } from '../../models/user.model';
import { AddCoachComponent } from '../add-coach/add-coach.component';
import { CoachService } from '../../../_core/services/coach.service';

@Component({
    selector: 'app-select-coaches',
    templateUrl: './select-coaches.page.html',
    styleUrls: ['./select-coaches.page.scss'],
    standalone: false
})
export class SelectCoachesPage implements OnDestroy {
    authUser: User;
    selectedUsers: User[] = [];
    playerGroups = [];

    showMale = true;
    showFemale = true;

    private readonly destroy$: Subject<void> = new Subject();
    isLoading: boolean;


    constructor(
        private userService: UserService,
        private modalController: ModalController,
        private coachService: CoachService 
    ) { }

    ionViewWillEnter() {
        this.getAllCoaches();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private getAllCoaches() {
        this.isLoading = true;
        this.coachService
            .getAllCoaches()
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => {
                    this.isLoading = false;
                })
            )
            .subscribe(
                (res) => {
                    this.authUser = res.data;
                    this.playerGroups = res.players;
                },
                err => {
                    //console.log(err)
                }
            );
    }

    async addCoach() {
        const modal = await this.modalController.create({
            component: AddCoachComponent,
        });

        await modal.present();

        const { data } = await modal.onDidDismiss();

        if (data) {
            const lastNameFirstChar = data.last_name?.charAt(0)?.toUpperCase();

            const pgIndex = this.playerGroups.findIndex(pg => {
                return pg.initial === lastNameFirstChar;
            });
            if (pgIndex === -1) {
                this.playerGroups.push({
                    initial: lastNameFirstChar,
                    players: [data],
                    count: 1
                });
            } else {
                this.playerGroups[pgIndex].players.push(data);
            }
    
            this.modalController.dismiss(data);
        }
        
    }

    selectCoach(i, j) {
        this.modalController.dismiss(this.playerGroups[i].players[j]);
    }

    canShowUser(sex) {
        if (sex === 'M') return this.showMale;
        else if (sex === 'F') return this.showFemale;
    }

    close() {
        this.modalController.dismiss();
    }

    log(pg) {
        //console.log('Player Group:', pg);
    }

    getUserSex(user) {
        if (user.biographicalInformation) {
          if (user.biographicalInformation.sex === 'M') return 'Male';
          else return 'Female';
        }
      }

}
